import { render, staticRenderFns } from "./WriteAddress.vue?vue&type=template&id=532cdb93&"
import script from "./WriteAddress.vue?vue&type=script&lang=js&"
export * from "./WriteAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports